import urljoin from 'url-join'
import RequestRelayServices from '@/services/requestRelay'
import DateUtils from '@/utils/dateUtils'
import ServicesUtils from '@/utils/servicesUtils'
import axios from 'axios'

/**
 * 
 * @param {number|string} cityId 
 */
async function getCovidHelp (cityId)
{
    const url = urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'covid-help')
    const response = await axios.get(url)

    return response.data
}

/**
 * 
 * @param {Date} date 
 */
async function getHealthStatsForDate (date)
{
    const url = urljoin('https://dashboard.covid19.data.gouv.fr/data/', `date-${DateUtils.toIsoString(date)}.json`)
    const response = await RequestRelayServices.get({ requestUrl: url, cacheControl: 60 * 60 * 5 })

    return response.data
}

export default { getCovidHelp, getHealthStatsForDate }


// WEBPACK FOOTER //
// ./src/services/covid.js